<template>
  <div class="player">
    <div v-loading="loading" class="video-container-wrap">
      <img v-show="showPlayBtn && !loading" :src="playIcon" class="video-control" @click="playVideo" />
      <video ref="videoPlayer" class="video-js vjs-default-skin" />
    </div>
  </div>
</template>
<script>
import videojs from 'video.js'
import 'videojs-youtube'
import 'video.js/dist/video-js.min.css'
import playIcon from '@/assets/video-play.svg'

export default {
  props: {
    posterPath: {
      type: String,
      required: true
    },
    videoSrc: {
      type: String,
      required: true
    },
    isOnlineVideo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      playIcon: playIcon,
      visible: false,
      loading: true,
      player: null,
      showPlayBtn: true,
      videoOptions: {
        autoplay: false,
        controls: true,
        poster: this.posterPath,
        techOrder: this.isOnlineVideo ? ['youtube'] : ['html5'],
        sources: [
          {
            type: this.isOnlineVideo ? 'video/youtube' : 'video/mp4',
            src: (this.isOnlineVideo ? '' : window.domainFromServer) + this.videoSrc
          }
        ]
      }
    }
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.videoOptions, () => {
      this.loading = false
    })
    this.player?.on('play', () => {
      this.showPlayBtn = false
    })

    this.player?.on('pause', () => {
      this.showPlayBtn = true
    })
  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose()
      this.player = null
    }
  },
  methods: {
    playVideo() {
      this.player.play()
      setTimeout(() => (this.showPlayBtn = false), 100)
    },
    pauseVideo() {
      if (!this.showPlayBtn) {
        this.player.pause()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';
.player {
  position: relative;
  width: 100%;
  max-width: 800px;
  @include media(mobile) {
    padding-bottom: 75%;
  }
}
.video-container-wrap {
  position: absolute;
  height: 100%;
  width: 100%;

  & .video-js {
    width: 100%;
    height: 100%;
    & /deep/ .vjs-big-play-button {
      display: none;
    }

    & /deep/ .vjs-poster {
      background-size: contain;
    }
  }
  & .video-control {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 62px;
    height: 62px;
    transform: translate(-50%, -50%);
    cursor: pointer;
    z-index: 1;
  }
}
</style>
